import React, {useState} from 'react';
import {
    Datagrid,
    FunctionField,
    ReferenceManyField, SelectField,
    Show,
    Tab,
    TabbedShowLayout,
    TextField,
} from 'react-admin';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm'
import { convertedDateWithTimeGMT} from "../../../Functions/ConvertedDate";
import {RatingSources} from "../../../Const/Enums";

export const AiQuestionShow = () => {

    return (
        <>
            <Show actions={<></>}>
                <TabbedShowLayout>
                    <Tab label="Details">
                        <TextField label='Question' source="name" sortBy="name"/>
                        <FunctionField label="Answer" source="answer" render={(record) => {
                             return <ReactMarkdown className="markdown-container" children={record.answer} remarkPlugins={[remarkGfm]} />;
                        }}/>
                        <TextField label='Sources' source="source" sortBy="source"/>
                        <FunctionField label="Token" source="details" render={(record) => {
                            return record.details ? record.details.total_tokens : '';
                        }}/>
                        <FunctionField label="Cost" source="details" render={(record) => {
                            return record.details ? record.details.estimated_cost : '';
                        }}/>
                        <FunctionField label='Created' source="created_at"  sortable={false} render={(record) => {
                            return <span>{convertedDateWithTimeGMT(record.created_at)}</span>
                        }}/>
                    </Tab>
                    <Tab label="Feedbacks" path={'feedback'}>
                        <div>
                            <ReferenceManyField reference="ai/questions-ratings/" addLabel={false} perPage={50} target="question_id" sort={{field: 'created_at', order: 'DESC'}}>
                                <Datagrid bulkActionButtons={false}>
                                    <SelectField label="Rating" source="rating" sortable={false} choices={RatingSources}/>
                                    <FunctionField label='Created At' source="created_at"  sortable={false} render={(record) => {
                                        return <span>{convertedDateWithTimeGMT(record.created_at)}</span>
                                    }}/>
                                </Datagrid>
                            </ReferenceManyField>
                        </div>
                    </Tab>
                </TabbedShowLayout>
            </Show>
        </>
    );
};
